namespace Gamification.Gamification {
    export enum ApiScriptOperazioniAzioniEnum {
        Aggiungere = 1,
        Sottrarre = 2
    }
    Serenity.Decorators.registerEnumType(ApiScriptOperazioniAzioniEnum, 'Gamification.Gamification.ApiScriptOperazioniAzioniEnum');
}
